import "./sidebar.css";
import React, {useState} from "react";
import { LeftMenuContext } from "../../context/LeftMenuContext";
import { Checkbox } from '@kui-react/checkbox'
import {Button} from "@kui-react/button";
// import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import { Flex } from '@kui-react/flex'
import { Label } from '@kui-react/label'
import localeConstants from "../../i18n/localization";
import { useSearchParams,useLocation} from "react-router-dom";
// Define the type for the state variable

function SideBar(props) {
  const [isLoaded] = useState(true);
  const [error] = useState(null);
  const sideBarState = React.useContext(LeftMenuContext);
  const { sliderMinMax,setPriceFilter} =
    sideBarState;
  const locale = props.locale;
  const localeStrings = localeConstants[locale.toUpperCase()];
  // eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const [priceFilterState, setpriceFilterState] = useState(false);
  const clickHandler = (sidecategory, subCategory, catId, event) => {
    var list = [...sideBarState.catWithSubCat];

    if (event.target.checked) {
      props.loader(false);
      props.setFilterFlag(true)
      let data_collection = {
        "category": "CTG_FILTER_CLICK",
        "manufacturer": "MNUF_FILTER_CLICK",
        "gpu": "GPU_FILTER_CLICK",
        "stock": "STOCK_FILTER_CLICK",
        "screen_size":"Screen_Size_FILTER_CLICK",
        "ram" :"System_Memory_FILTER_CLICK",
        "gpu_memory_size":"GPU_Memory_Size_FILTER_CLICK",
        "video_memory":"Video_Memory_FILTER_CLICK",
        "nv_technology": "NVIDIA_technology_FILTER_CLICK"
    };
      
      props.etailCall(data_collection[sidecategory], subCategory)
      list.push({ category: sidecategory, subCategory: subCategory });
      sideBarState.setCatWithSubCat(list);
      // sideBarState.setPriceSort("lp");
      
    } else {
      let new_list = list.filter((f) => f.subCategory !== subCategory);
      sideBarState.setCatWithSubCat(new_list);
      props.setFilterFlag(false)

      const searchPrms = {};
      const unique_cats = [
        ...new Set(new_list.map((item) => item.category)),
      ];
      unique_cats.forEach((cat) => {
        const sub_cats = new_list.filter(
          (item) => item.category === cat
        );
        const unique_subcats = [
          ...new Set(sub_cats.map((item) => item.subCategory)),
        ].join(",");
        searchPrms[cat] = unique_subcats;
      });
      setSearchParams({ ...searchPrms, tab_id: urlParams.has("tab_id") ? urlParams.get("tab_id") :''});
      return
    } 
    sideBarState.setCurrentFilter({
      ...sideBarState.currentFilter,
      section: subCategory.toUpperCase(),
      type: catId.toUpperCase(),
    });
    return;

  };
  const resetFilter = () => {
    props.loader(false);
    props.setFilterFlag(true);
    sideBarState.setCatWithSubCat([]);
    sideBarState.setPriceSort("lp");
    if(sliderMinMax[0]===undefined||sliderMinMax[1]===undefined){
      sliderMinMax[0]=0;
      sliderMinMax[1]=1000;
    }
   
    setpriceFilterState(false)
    if ((urlParams.get("category")===null && 
         urlParams.get("gpu")===null && 
         urlParams.get("manufacturer")===null&&
         urlParams.get("nv_technology")&&
         urlParams.get("screen_size")&&
         urlParams.get("ram")&&
         urlParams.get("gpu_memory_size")
         
         )) {
      console.log('ResetButton initialize')
      props.setResetFilterState(true)
    }
    setSearchParams({ tab_id: urlParams.get("tab_id") });
    setPriceFilter(sliderMinMax);
    props.setFilterFlag(false);
    return
  };

  // const handleRangeInput = (e) => {
  //  const roundValue = e?.map((val) => Math.round(val));
  //   if(roundValue[0]>roundValue[1]||roundValue[0]===roundValue[1] ){
  //     setPriceFilter(sliderMinMax);
  //     props.loader(true);
  //     return;
  //   }
  //   props.setFilterFlag(true)
  //   //setApplyPriceFilter(false);
  //   setApplyPriceFilter(true);
  //   setPriceFilter(e?.map((val) => Math.round(val)));
  
  //   // props.loader(false);
  //   return
  // };


  // const setRangeValues = (e) => {
  //   const roundValue = e?.map((val) => Math.round(val));
  //   setPriceFilter(roundValue);
  // };
  const showMoreFilters = (className) => {
    var element = document.getElementsByClassName(className);
    for (let i = 0; i < element.length; i++) {
      element[i].classList.remove("hide");
    }
    let lessbutton = document.getElementsByClassName(
      className + "-show-less-content"
    );
    lessbutton[0].classList.remove("hide");
    let morebutton = document.getElementsByClassName(
      className + "-show-more-content"
    );
    morebutton[0].classList.add("hide");
  };
  const showLessFilters = (className) => {
    var element = document.getElementsByClassName(className);
    for (let i = 0; i < element.length; i++) {
      element[i].classList.add("hide");
    }
    let morebutton = document.getElementsByClassName(
      className + "-show-more-content"
    );
    morebutton[0]?.classList.remove("hide");
    let lessbutton = document.getElementsByClassName(
      className + "-show-less-content"
    );
    lessbutton[0]?.classList.add("hide");
  };
  return (
    <>
      {error ? (
        <div>Error: {error.message}</div>
      ) : !isLoaded ? (
        <div></div>
      ) : (
            <>
              <Button
                shape="rectangle"
                size="regular"
                tag="button"
                type="secondary"
                variant="solid"
                className={sideBarState.catWithSubCat.length > 0 || priceFilterState ? "filter-btn-enable" : "nv-filter-btn"}
                onClick={() => resetFilter()}
                disabled={sideBarState.catWithSubCat.length === 0 && !priceFilterState}
              >
                {localeStrings.ResetButton}
              </Button>
              <div className="category">

                {sideBarState?.categories?.map((item, indx) => {
                  let new_list = [];
                  if (item.filterValues && item.filterValues.length > 0) {
                    new_list = item.filterValues.filter(
                      (f) => f.dispValue !== "GIGABYTE" && f.dispValue !== "NULL"
                    );
                    new_list.sort((a, b) => {
                      return a.dispValue > b.dispValue ? -1 : 1;
                    });
                  }

                  if (item.displayName === "manufacturer") {
                    new_list = [...item.filterValues];
                    new_list.sort((a, b) => {
                      return a.dispValue.toLowerCase() < b.dispValue.toLowerCase()
                        ? -1
                        : 1;
                    });
                  }
                  return (
                    item.displayName !== "nv_technology" && item.displayName !== "price" &&
                    /* eslint-disable no-useless-concat */
                    <div key={`cat-${indx}`} style={{ 'display': (new_list?.length === 1 && item.displayName === 'category')||(new_list?.length === 0) || new_list[0]?.dispValue === '|' ? 'none' : 'block' }}>
                      
                      <div className="categoryHeader">
                        {
                          localeStrings?.filterlabels?.[
                          item.displayName.toLowerCase()
                          ]
                        }
                        <button
                          className={
                            "nv-show-more-content hide " +
                            // (item.displayName !== "manufacturer" ? " hide " : "") +
                            item.displayName +
                            "-category-header-filter-show-more-content"
                          }
                          onClick={() => {
                            showMoreFilters(
                              item.displayName + "-category-header-filter"
                            );
                          }}
                        >
                          <span className="title"></span>
                        </button>
                        <button
                          className={
                            "show-less-content  " +
                            // (item.displayName === "manufacturer" ? " hide " : "") +
                            item.displayName +
                            "-category-header-filter-show-less-content"
                          }
                          onClick={() => {
                            showLessFilters(
                              item.displayName + "-category-header-filter"
                            );
                          }}
                        >
                          <span className="title"></span>
                        </button>
                      </div>
                      <div
                        className={
                          "category-subheader-wrapper " +
                          item.displayName +
                          "-category-header-filter"
                          // (item.displayName === "manufacturer" ? " hide " : "")
                        }
                      >
                        {new_list &&
                          new_list.length > 0 &&
                          new_list?.map((filter, i) => {
                            const val = sideBarState.catWithSubCat.filter(
                              (f) =>
                                f.category === item.displayName &&
                                f.subCategory === filter.dispValue
                            );
                            let new_name = localeStrings?.filterCategories?.[
                              filter.dispValue.toLowerCase()
                            ]
                              ? localeStrings?.filterCategories?.[
                              filter.dispValue.toLowerCase()
                              ]
                              : filter.dispValue.toUpperCase().trim();
                            return (
                              <div key={new_name}>
                                {new_name === "ABS" ||
                                  new_name === "SKYTECH" ||
                                  new_name === "YEYIAN" ||
                                  new_name === "MEK HERO" ||
                                  new_name === "COBRATYPE" ||
                                  new_name === "ADENINE" ? (
                                  ""
                                ) : (
                                  <div
                                    className={
                                      "form-check filters " +
                                      (i > 7 ? item.displayName + "filter hide" : " ")
                                    }
                                    key={`subcat-${i}`}
                                  >
                                    <Flex
                                      align="center"
                                      gap="sm"
                                    >
                                      <Checkbox
                                        css={{ background: '#000' }}
                                        id={`interactive-checkbox-example-${new_name}`}
                                        value={
                                          new_name === "AORUS"
                                            ? `${new_name} / GIGABYTE`
                                            : new_name === "ACER AMERICA"
                                              ? "ACER"
                                              : new_name === "ASUS"
                                                ? "ASUS / ROG"
                                                : new_name === "G_SYNC"
                                                  ? "G SYNC"
                                                  : new_name === "RAY_TRACING"
                                                    ? "RAY TRACING"
                                                    : new_name.replace(/RTX/g, 'GeForce RTX').replace(/GTX/g, 'GeForce RTX').replace(/&QUOT;/g, "''")
                                        }
                                        checked={val.length > 0 ? true : false}
                                        onChange={(event) =>
                                          clickHandler(
                                            item.displayName,
                                            filter.dispValue,
                                            item.filterField,
                                            event
                                          )
                                        }
                                      />
                                      <Label css={{ fontFamily: 'NVIDIA-NALA,Arial,Helvetica,Sans-Serif', color: "#eee", fontWeight: '400', fontSize: '16px', lineHeight: '32px' }} htmlFor="name">{filter.dispValue}</Label></Flex>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        
                          <div className="showMoreLessWrapper"   style={{ 'visibility':new_list.length > 8?'visible':'hidden'}}>
                            <button
                              className={
                                "nv-show-more-content " +
                                item.displayName +
                                "filter-show-more-content positon-arrow"
                              }
                              onClick={() => {
                                showMoreFilters(item.displayName + "filter");
                              }}
                            >
                              <span className="title">{localeStrings?.showMore}</span>
                            </button>
                            <button
                              className={
                                "show-less-content hide " +
                                item.displayName +
                                "filter-show-less-content positon-arrow"
                              }
                              onClick={() => {
                                showLessFilters(item.displayName + "filter");
                              }}
                            >
                              <span className="title">{localeStrings?.showLess}</span>
                            </button>
                          </div>
                        
                      </div>
                    </div>
                  );
                })}
                {/* <div className="price-range-container price-category-header-filter">
            <div className="mb-55">
              <div className="nv-min-input-div">
                <span className="price-doller">{localeStrings?.currency==='₩'?'':localeStrings?.currency}</span>
                <input
                  readOnly
                  type="number"
                  step="any"
                  min={sliderMinMax[0]}
                  max={sliderMinMax[1]}
                  className="filter-input"
                  value={priceFilter[0]}
                  onChange={(e) => {
                    handleRangeInput([e.target.value, priceFilter[1]]);
                  }}
                  onKeyUp={(e) => {
                    if (e.keyCode === 13) {
                      handleRangeInput([e.target.value, priceFilter[1]]);
                    }
                  }}
                />
              </div>
              <div>
                <span className="price-doller">{localeStrings?.currency==='₩'?'':localeStrings?.currency}</span>
                <input
                  readOnly
                  type="number"
                  step="any"
                  min={sliderMinMax[0]|| 0}
                  max={sliderMinMax[1]|| 10000}
                  className="filter-input"
                  value={priceFilter[1]}
                  onChange={(e) => {
                    handleRangeInput([priceFilter[0], e.target.value]);
                  }}
                  onKeyUp={(e) => {
                    if (e.keyCode === 13) {
                      handleRangeInput([priceFilter[0], e.target.value]);
                    }
                  }}
                />
              </div>
            </div>
            <Nouislider
              onSlide={(e) => {handleRangeInput(e);return}}  
              animate={true}
              range={{
                min:  sliderMinMax[0] || 0,
                max:  sliderMinMax[1] || 1000,
              }}
              start={priceFilter}
              tooltips={false}

              connect={true}
              behaviour="tap"
              onChange={(e) => {
                // handleRangeInput(e);
                 //props.setFilterFlag(true)
                // // console.log("change");
                // setApplyPriceFilter(false);
                // setApplyPriceFilter(true);
                // setPriceFilter(e?.map((val) => Math.round(val)));
                 setpriceFilterState(true)
                // return
              }}
            />
          </div>
           */}
              </div>
            </>
      )}
    </>
  );
}
export default SideBar;
